import { useEffect, useMemo, useState } from "react";
import type { PlatformClient } from "../../platform/supabase";

type Catalog={
  available:Array<{
    versionId:string;instrumentId:string;instrumentName:string;title:string;description?:string|null;
    versionLabel:string;gradeMin?:number|null;gradeMax?:number|null;estimatedMinutes?:number|null;ownerName:string;
  }>;
  administrations:Array<{
    administrationId:string;versionId:string;title:string;instrumentName:string;status:string;
    assignedAt:string;startedAt?:string|null;completedAt?:string|null;
  }>;
};

function statusLabel(status:string){
  if(status==="ASSIGNED") return "배정";
  if(status==="IN_PROGRESS") return "진행 중";
  if(status==="COMPLETED") return "완료";
  if(status==="CANCELLED") return "취소";
  return status;
}

export function CenterAssessmentPanel({
  client,schoolId,learnerId,onChanged
}:{
  client:PlatformClient;schoolId:string;learnerId:string;onChanged():void;
}){
  const [catalog,setCatalog]=useState<Catalog|null>(null);
  const [versionId,setVersionId]=useState("");
  const [busy,setBusy]=useState(false);
  const [error,setError]=useState("");
  const [refresh,setRefresh]=useState(0);

  useEffect(()=>{
    let active=true;
    client.rpc("center_assessment_catalog",{p_school_id:schoolId,p_learner_id:learnerId}).then(({data,error})=>{
      if(!active)return;
      if(error){setError(error.message);return;}
      const next=data as Catalog;
      setCatalog(next);
      setVersionId((v)=>next.available.some((x)=>x.versionId===v)?v:next.available[0]?.versionId || "");
    });
    return()=>{active=false;};
  },[client,schoolId,learnerId,refresh]);

  const selected=useMemo(()=>catalog?.available.find((x)=>x.versionId===versionId) || null,[catalog,versionId]);

  async function assign(){
    if(!versionId)return;
    setBusy(true);setError("");
    const {error}=await client.rpc("center_assign_assessment",{p_school_id:schoolId,p_learner_id:learnerId,p_version_id:versionId});
    setBusy(false);
    if(error){setError(error.message);return;}
    setRefresh((v)=>v+1);
    onChanged();
  }

  if(!catalog) return <section className="center-assessment-panel"><p className="muted">검사 배정 정보를 불러오는 중…</p></section>;

  return (
    <section className="center-assessment-panel">
      <div className="panel-title"><strong>심리검사·진로검사</strong><span>발행본만 배정</span></div>
      {error && <p className="error">{error}</p>}

      <div className="assessment-assign-row">
        <select value={versionId} onChange={(e)=>setVersionId(e.target.value)}>
          {catalog.available.map((item)=><option key={item.versionId} value={item.versionId}>{item.instrumentName} · {item.title} · v{item.versionLabel}</option>)}
        </select>
        <button className="primary compact-button" disabled={busy||!versionId} onClick={assign}>{busy?"배정 중…":"검사 배정"}</button>
      </div>
      {selected && <p className="studio-hint">{selected.ownerName} · 약 {selected.estimatedMinutes || "-"}분{selected.description ? " · "+selected.description : ""}</p>}

      <div className="assessment-admin-list">
        {catalog.administrations.map((item)=>(
          <div className="review-line" key={item.administrationId}>
            <div><strong>{item.title}</strong><span>{item.instrumentName}</span></div>
            <span className={item.status==="COMPLETED"?"status-pill good":"status-pill"}>{statusLabel(item.status)}</span>
          </div>
        ))}
        {!catalog.administrations.length && <p className="case-empty">아직 배정된 검사가 없습니다.</p>}
      </div>
    </section>
  );
}
